// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yBtm","left":"styles_left__1y9yR","desktopActions":"styles_desktopActions__2KFNs","title":"styles_title__1HIhu"};